import { useMemo } from "react";

import { IntlShape } from "react-intl";

import ActivityStatusOption from "@mapmycustomers/shared/enum/activity/ActivityStatusOption";

import { sortOptionsMessages } from "./sortOptionsMessages";

export const useSortOptions = (intl: IntlShape, activityStatusOption: ActivityStatusOption) =>
  useMemo(() => {
    if (activityStatusOption === ActivityStatusOption.ALL) {
      return ["createdAt", "updatedAt", "startAt", "completedAt"].map((fieldName) => {
        const fieldLabel = fieldName === "startAt" ? "dueDate" : fieldName;
        return {
          label: intl.formatMessage(
            sortOptionsMessages[fieldLabel as keyof typeof sortOptionsMessages]
          ),
          value: fieldName,
        };
      });
    } else if (activityStatusOption === ActivityStatusOption.OVERDUE) {
      return ["createdAt", "updatedAt", "startAt"].map((fieldName) => {
        const fieldLabel = fieldName === "startAt" ? "dueDate" : fieldName;
        return {
          label: intl.formatMessage(
            sortOptionsMessages[fieldLabel as keyof typeof sortOptionsMessages]
          ),
          value: fieldName,
        };
      });
    } else if (activityStatusOption === ActivityStatusOption.COMPLETED) {
      return ["createdAt", "updatedAt", "startAt", "completedAt"].map((fieldName) => ({
        label: intl.formatMessage(
          sortOptionsMessages[fieldName as keyof typeof sortOptionsMessages]
        ),
        value: fieldName,
      }));
    } else if (activityStatusOption === ActivityStatusOption.NOT_SCHEDULED) {
      return ["createdAt", "updatedAt"].map((fieldName) => ({
        label: intl.formatMessage(
          sortOptionsMessages[fieldName as keyof typeof sortOptionsMessages]
        ),
        value: fieldName,
      }));
    } else if (activityStatusOption === ActivityStatusOption.UPCOMING) {
      return ["createdAt", "updatedAt", "startAt"].map((fieldName) => ({
        label: intl.formatMessage(
          sortOptionsMessages[fieldName as keyof typeof sortOptionsMessages]
        ),
        value: fieldName,
      }));
    }
  }, [intl, activityStatusOption]);
